import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, isAuthenticated, removeToken } from './auth';
import Loader from './components/Loader';

export default function PrivateRoute({ children }) {
  const token = getToken();

  // Si pas de token ou token expiré, rediriger vers login
  if (!token || !isAuthenticated()) {
    removeToken();
    return <Navigate to="/login" replace />;
  }

  return children;
} 